import React, { useCallback, useState } from "react";

import { ChatWrapper, Layout, LoadingPositioner } from "./Chatbot.styled";
import { withRouter } from "react-router-dom";
import { withRefluxStore } from "../../../Stores";
import AdAssistantStore from "../AdAssistantStore";
import { useTranslation } from "react-i18next";
import NavigationSteps from "../navigation-steps/NavigationSteps";
import ChatForm from "./chat-form/ChatForm";
import MultiStepLoader from "./multi-step-loader/MultiStepLoader";

const Chatbot = ({ isBudgetCheck = false, isOnboardingCampaign = false, history, match }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { campaignId } = match.params;

  const renderContent = useCallback(() => {
    if (loading) {
      return (
        <LoadingPositioner>
          <MultiStepLoader />
        </LoadingPositioner>
      );
    }
    return (
      <ChatForm
        emitLoading={setLoading}
        isBudgetCheck={isBudgetCheck}
        isOnboardingCampaign={isOnboardingCampaign}
        campaignId={campaignId || null}
      />
    );
  }, [loading, isBudgetCheck, isOnboardingCampaign, campaignId]);

  const handleClose = () => {
    history.push("/assistant-dashboard");
  };

  return (
    <Layout>
      <NavigationSteps step={t("Campaign assistant")} onClose={handleClose} hideSteps={true} />
      <ChatWrapper>{renderContent()}</ChatWrapper>
    </Layout>
  );
};

export default withRouter(withRefluxStore(Chatbot, [AdAssistantStore]));
